import * as actionTypes from './actionTypes';
import { BlockReason } from '@lucky7ventures/bff-types';

interface LoginSuccessOpts {
  isRegistration?: boolean;
  blockReason?: BlockReason | null;
  isAutoLogin?: boolean;
  isTimeoutBlocked?: boolean;
}

// Login
export const loginSuccess = (token: string, opts: LoginSuccessOpts = {}) => ({
  type: actionTypes.LOGIN_SUCCESS as typeof actionTypes.LOGIN_SUCCESS,
  token,
  isRegistration: opts.isRegistration ?? false,
  blockReason: opts.blockReason ?? null,
  isAutoLogin: opts.isAutoLogin ?? false,
  isTimeoutBlocked: opts.isTimeoutBlocked ?? false,
});

// Logout
export const logout = () => ({
  type: actionTypes.LOGOUT as typeof actionTypes.LOGOUT,
});

export const logoutSuccess = () => ({
  type: actionTypes.LOGOUT_SUCCESS as typeof actionTypes.LOGOUT_SUCCESS,
});

export const loginSuccessDone = () => ({
  type: actionTypes.LOGIN_SUCCESS_DONE as typeof actionTypes.LOGIN_SUCCESS_DONE,
});

export const setTimeoutBlocked = (isTimeoutBlocked: boolean) => ({
  type: actionTypes.SET_TIMEOUT_BLOCKED as typeof actionTypes.SET_TIMEOUT_BLOCKED,
  isTimeoutBlocked,
});
